import { createSelector } from 'reselect';
import { SYSTEM_FONT_VALUES } from 'EmailEditorUI/constants/TemplateSettingsConstants';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
const getConfigValues = basicSelector(state => state.configValues);
export const getWebfonts = createSelector([getConfigValues], configValues => {
  const webfonts = configValues.availableWebfonts ? configValues.availableWebfonts : {};
  return Object.fromEntries(Object.entries(Object.assign({}, webfonts, SYSTEM_FONT_VALUES)).map(([key, value]) => [key, `${key},${value}`]));
});
export const getWebfontsList = createSelector(getWebfonts, webfonts => {
  return Object.entries(webfonts).reduce((acc, [font, fontStyle]) => {
    const fontValue = font.replace('+', ' ');
    acc.push({
      text: fontValue,
      value: fontStyle
    });
    return acc;
  }, []).sort((a, b) => a.text > b.text ? 1 : -1);
});
export const getWebfontsForTransform = createSelector(getWebfontsList, list => list.map(({
  text,
  value
}) => [value, text]));